<template>
    <div class="SwissConstant">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 40px)">
                <DxDataGrid ref="SwissConstantList"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            @initialized="onInitialized"
                            @init-new-row="onInitNewRow"
                            @row-prepared="onRowPrepared"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxEditing :allow-updating="true"
                               :allow-deleting="true"
                               :allow-adding="true"
                               :use-icons="true"
                               mode="cell" />

                    <DxPaging :page-size="500" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="true" />

                    <DxColumn data-field="id"
                              caption="#"
                              :allowEditing="false"
                              width="50"
                              alignment="center"
                              cell-template="idColumnTemplate" />
                    <DxColumn data-field="customerId"
                              caption="Ügyfél-azonosító"
                              :allowEditing="false"
                              header-cell-template="title-header" />
                    <DxColumn data-field="name"
                              caption="Díjfizető neve"
                              :allowEditing="false"
                              header-cell-template="title-header" />
                    <DxColumn data-field="allocatorID"
                              caption="Radiátor azonosító"
                              alignment="right"
                              datatype="string"
                              header-cell-template="title-header" />
                    <DxColumn data-field="swissConstant"
                              caption="Svájci konstans"
                              alignment="right"
                              header-cell-template="title-header" />
                    <DxColumn caption="Akciók"
                              sortOrder="0"
                              :allow-resizing="false"
                              :allow-reordering="false"
                              :min-width="60"
                              :width="100"
                              type="buttons">
                        <DxButton name="edit"
                                  hint="Szerkesztés"
                                  icon="background"
                                  :visible="false" />
                        <DxButton name="save"
                                  hint="Mentés"
                                  icon="check" />
                        <DxButton name="cancel"
                                  hint="Mégsem"
                                  icon="close" />
                        <DxButton name="delete"
                                  hint="Törlés"
                                  icon="trash" />
                    </DxColumn>

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #uploadFile="{ data }">
                        <div>
                            <DxBtn name="upload"
                                   hint="Fájl feltöltés"
                                   text="Fájl feltöltés"
                                   icon="upload"
                                   @click="importBtnClick" />

                            <form style="display:none;">
                                <input type="file" ref="fileupload" name="files" accept=".xls,.xlsx" @change="importFile" />
                            </form>
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>

        <DxLoadPanel :position="position"
                     v-model:visible="loadingVisible"
                     :show-indicator="true"
                     :show-pane="true"
                     :shading="true"
                     :close-on-outside-click="false"
                     shading-color="rgba(0,0,0,0.4)" />
    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import SwissConstantService from "../services/SwissConstant.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import notify from "devextreme/ui/notify";
    import { DxLoadPanel } from 'devextreme-vue/load-panel';

    export default {
        name: 'SwissConstant',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxLoadPanel
        },
        data() {
            return {
                datagrid: null,
                loadingVisible: false,
                position: { of: '#app' },
                dataSource: new CustomStore({
                    key: "id",
                    load: () => SwissConstantService.get(),
                    insert: (values) => {
                        return SwissConstantService.insert(values);
                    },
                    update: (key, values, reorder) =>
                        SwissConstantService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => SwissConstantService.delete(key)
                }),
            };
        },
        methods: {
            onInitialized(e, level) {
                this.datagrid = e.component;
            },
            onInitNewRow(e) {
                new Promise(resolve => setTimeout(resolve, 10)).then(()=>{
                    e.component.saveEditData();
                    e.component.deselectAll();
                });
            },
            onRowPrepared(e) {
                if (e.component.getVisibleRows()[e.rowIndex] &&
                    e.component.getVisibleRows()[e.rowIndex].isNewRow &&
                    e.rowType == 'data')
                    e.rowElement.classList.add('d-none');
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    template: 'uploadFile'
                });
            },
            importBtnClick(e) {
                this.$refs.fileupload.click();
            },
            importFile() {
                var fileExtension = ['xls', 'xlsx'];
                var filename = this.$refs.fileupload.value;

                if (filename.length == 0) {
                    notify({
                        message: 'Válasszon ki egy excel fájlt!',
                        position: {
                            at: "top",
                            offset: "0 40"
                        }
                    }, "error", 5000);
                    return false;
                }
                else {
                    var extension = filename.replace(/^.*\./, '');
                    if (!fileExtension.includes(extension)) {
                        notify({
                            message: 'A fájl típusa nem megfelelő!',
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "error", 5000);
                        return false;
                    }
                }

                var fdata = new FormData();
                var fileUpload = this.$refs.fileupload;
                var files = fileUpload.files;
                fdata.append(files[0].name, files[0]);

                this.loadingVisible = true;

                SwissConstantService.import(fdata).then(result => {
                    this.loadingVisible = false;
                    this.datagrid.refresh();

                    notify({
                        message: 'Az importálás sikeresen befejeződött!',
                        position: {
                            at: "top",
                            offset: "0 40"
                        }
                    }, "success", 5000);
                    this.loadingVisible = false;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }
    ::v-deep .grid {
        fill-opacity: 0;
    }
    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        margin-top: 10px;
        margin-bottom: 10px;
        padding-right: 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }
    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }
    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }
    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }
    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }
</style>